import {
  loadablePage as loadable,
  withDefaultLoaderModifiers,
} from "@gamedev-web/gamedev-sdk-core";

export const VisualStudioAssetsPage = loadable(() =>
  withDefaultLoaderModifiers(import("./VisualStudioAssetsPage"))
);
